var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('bar'),_c('router-view',{staticClass:"mainRouterView"}),_c('foot',{on:{"jumpCallBack":_vm.jumpCallBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }